import { PureLightTheme } from "../../../styles/theme"

export const H1Welcome = {
    [PureLightTheme.breakpoints.down('sm')]: {
        fontSize: '20px',
    }
}